import { reactive, ref, watch } from 'vue';

export type UseRecruitDialogState = {
  isOpen: boolean;
  budgetGroupTwrn: string | undefined;
};

const DEFAULT_STATE: UseRecruitDialogState = {
  isOpen: false,
  budgetGroupTwrn: undefined,
};

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseRecruitDialogState>(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

export function useRecruitDialog() {
  async function open(budgetGroupTwrn: string) {
    state.budgetGroupTwrn = budgetGroupTwrn;
    state.isOpen = true;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
  };
}
